export default {
  // Tạo mới
  RestoreNewData: 1,

  // Replace vào db hiện có
  RestoreReplate: 2,
};
